import React, {useState, createContext, useEffect} from 'react';
import { getToken } from '../repositories/token';
import { getUser } from '../repositories/user';

export const Context = createContext(null);

export const ContextProvider = ({ children }) => {
  let savedUser;

  const [user, setUser] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectUrl, setSelectUrl] = useState(null);
  const [select, setSelect] = useState(null);


  useEffect(() => {
    if (typeof window !== 'undefined') {
      const token = getToken();
      if (token) {
        const userData = getUser();
        setUser(userData);
      }
    }
  }, []);

  const store = {
    user: { user, setUser },
    groupedProductQuantity: { quantity, setQuantity },
    groupedProductSelectValue: { select, setSelect },
    selectUrl,
    setSelectUrl,
  };

  return <Context.Provider value={store}>{children}</Context.Provider>;
};
